import { Box, Image } from "grommet";
import { AppToaster } from "./Toaster";
// import hpeBgImg from "../assets/hpe-bg.jpg";
import greenLakeImg from "../assets/GreenLake-BGImage.jpg";
import logoIntelImg from "../assets/LogoINTEL.png";
import ezmeralImg from "../assets/LogoEzmeral.png";
import amdImg from "../assets/LogoAMD.png";
import nutranixImg from "../assets/LogoNUTANIX.png";
import microsoftImg from "../assets/logoMICROSOFT.png";
import redhatImg from "../assets/logoREDHAT.png";
import vmwareImg from "../assets/logoVMWARE.png";
import suseImg from "../assets/logoSUSE.png";
import nvidiaImg from "../assets/logoNVIDIA.png";
import brocadeImg from "../assets/logoBrocade.png";
import emulexImg from "../assets/LogoEmulex.png";
import thalesImg from "../assets/thales.png";
import cloudcasa from "../assets/logocloudcasa.png";

export const goToBack = (history) => {
  history.goBack();
};

export const showToast = (messageObj) => {
  AppToaster.show({ message: "Test Toasted.", ...messageObj });
};

const importAll = (r) => {
  let images = {};
  r.keys().map((item, index) => {
    images[item.replace("./", "")] = r(item);
  });
  return images;
};

const images = importAll(
  require.context("../assets", false, /\.(png|jpe?g|svg)$/),
);

export const renderImgFromAssets = (fileName) => {
  let imgFile = logoIntelImg;

  /* if (images && images.length > 0) {
    images.map((imag) => {
      if (imag.include(fileName)) {
        imgfile = images[fileName];
        return (
          <Box height="small" width="small">
            <Image fit="contain" src={imgFile} />
          </Box>
        );
      }
    });
  } */

  if (fileName.includes("GreenLake")) {
    imgFile = greenLakeImg;
  }
  if (fileName.includes("Ezmeral")) {
    imgFile = ezmeralImg;
  }
  if (fileName.includes("AMD")) {
    imgFile = amdImg;
  }
  if (fileName.includes("NUTANIX")) {
    imgFile = nutranixImg;
  }
  if (fileName.includes("MICROSOFT")) {
    imgFile = microsoftImg;
  }
  if (fileName.includes("VMWARE")) {
    imgFile = vmwareImg;
  }
  if (fileName.includes("REDHAT")) {
    imgFile = redhatImg;
  }
  if (fileName.includes("SUSE")) {
    imgFile = suseImg;
  }
  if (fileName.includes("NVIDIA")) {
    imgFile = nvidiaImg;
  }
  if (fileName.includes("Brocade")) {
    imgFile = brocadeImg;
  }
  if (fileName.includes("Emulex")) {
    imgFile = emulexImg;
  }
  if (fileName.includes("thales")) {
    imgFile = thalesImg;
  }
  if (fileName.includes("cloudcasa")) {
    imgFile = cloudcasa;
  }
  return (
    // <Box height="small" width="small" border>
    <Image fit="contain" src={imgFile} />
    // </Box>
  );
};
